/**
 * Utility functions for date formatting and manipulation using date-fns
 */
import { format } from 'date-fns';

/**
 * Formats a bundle track date (YYYY-MM-DD) as a human-readable label.
 * Parsed as a local date to avoid timezone shifting the calendar day.
 *
 * @param dateString - date in YYYY-MM-DD format (e.g. "2026-06-15")
 * @returns formatted label (e.g. "Jun 15, 2026"), or the original string if invalid
 */
export function formatBundleDate(dateString: string): string {
  const [year, month, day] = dateString.split('-').map(Number);

  if (!year || !month || !day) {
    return dateString;
  }

  return format(new Date(year, month - 1, day), 'MMM d, yyyy');
}
